"use client";

import React from "react";
import { Droplets, BookOpen, HeartHandshake } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const islamicTeachings = [{
  title: "Mobilità Globale",
  quote: "Eccellenza nella Gestione dei Visti",
  source: "Standard Internazionali",
  explanation: "Forniamo soluzioni strategiche per la mobilità internazionale, garantendo processi fluidi e conformità normativa per ogni destinazione globale.",
  icon: Droplets
}, {
  title: "Consulenza Aziendale",
  quote: "Supporto Strategico per il Business",
  source: "Corporate Services",
  explanation: "Assistiamo le imprese nell'inserimento di talenti internazionali, gestendo ogni aspetto burocratico con precisione e rapidità operativa.",
  icon: BookOpen
}, {
  title: "Affidabilità e Assistenza Professionale",
  quote: "Servizi Extragiudiali e Gestione Documentale",
  source: "Professionalità Garantita",
  explanation: "Supporto professionale nella gestione di pratiche, controversie e documentazione, con un approccio riservato, organizzato e orientato alla tutela degli interessi del cliente.",
  icon: HeartHandshake
}];
export default function WaterInIslamicPerspective() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="233985" id="assistenza-strategica" className="dark bg-background text-foreground relative flex min-h-[90vh] items-center justify-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 scale-105 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/corporate_global_nexus_bg.png)] bg-cover bg-center opacity-30 blur-md transition-transform duration-1000"></div>
        <div className="absolute inset-0 bg-background/90 backdrop-blur-sm"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-background/60"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        {}
        <div ref={headerReveal.ref} className={`mx-auto max-w-3xl text-center transition-all duration-1000 ease-out ${headerReveal.isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h2 className="font-default text-accent mb-6 text-5xl font-bold tracking-tighter md:text-7xl lg:text-8xl">
            Risoluzione Rapida
          </h2>
          <p className="text-muted-foreground md:text-xl mb-12 text-lg leading-relaxed font-default">
            WORLD IMMIGRATION DI DELGADO offre un'assistenza strategica d'élite per navigare la complessità della mobilità internazionale. Un ponte sicuro tra le vostre ambizioni globali e la realtà normativa.
          </p>
        </div>

        {}
        <div ref={gridReveal.ref} className={`mx-auto grid max-w-6xl grid-cols-1 gap-8 md:grid-cols-3 transition-all duration-1000 delay-300 ease-out ${gridReveal.isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          {islamicTeachings.map((item, i) => {
          const Icon = item.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="border-accent/20 bg-[#162031]/80 hover:bg-[#162031]/95 hover:border-accent/50 h-full transition-all duration-500 backdrop-blur-xl rounded-lg shadow-2xl hover:shadow-[0_20px_40px_rgba(0,0,0,0.4),0_0_30px_rgba(255,200,41,0.2)]">
                  <CardHeader className="text-center pb-4">
                    <div className="bg-accent/10 border border-accent/20 mx-auto mb-6 flex size-20 items-center justify-center rounded-lg transition-transform duration-500 group-hover:scale-110">
                      <Icon className="text-accent size-10 drop-shadow-[0_0_8px_rgba(255,200,41,0.4)]" />
                    </div>
                    <CardTitle className="font-default text-foreground text-2xl font-bold tracking-tight">
                      {item.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="text-center">
                    <div className="mb-6">
                      <p className="text-accent font-serif text-xl leading-tight md:text-2xl font-semibold italic">
                        {item.quote}
                      </p>
                      <span className="text-foreground mt-2 block text-xs font-mono uppercase tracking-widest">
                        {item.source}
                      </span>
                    </div>
                    <p className="text-foreground leading-relaxed font-default text-sm">
                      {item.explanation}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}